import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsBlogPage } from 'types/cms/single-types'

/**
 * Get the blog page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsBlogPage | undefined>}
 */
const getBlogPage = async (locale: Language = Language.DUTCH): Promise<CmsBlogPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsBlogPage>>(`${process.env.CMS_API_URL}/blog?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getBlogPage
